const config = {
  // URL:'https://cors-anywhere.herokuapp.com/api.onegml.com/v1',
  URL: "https://api.onegml.com/v1",
  REVALIDATE_URL: "https://cdhx.gmlperformance.com/api/revalidate",
  USER: "onegmlapi",
  PASS: "O1n6e0G4M7L",
};

export const { URL, USER, PASS, REVALIDATE_URL } = config;
